








































































































































































































import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { RequestMessage, IRequestMessage } from '@/types/_'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

type RecebimentoStatus = 'Iniciado' | 'Erro' | 'Concluido' | 'Cancelado' | 'Pendente' | 'Finalizado'

type IntegracaoErro = {
  erroId: number
  mensagem: string
  criadoPor: string
  criadoEm: string
}

type IntegracaoRepasse = {
  integracaoRepasseId: number
  recebimentoId: number
  mesReferencia: string
  fontePagadoraNome: string
  recebimentoStatus: RecebimentoStatus | string
  recebimentoTipo: string
  criadoEm: string
  criadoPorNome: string
  observacao: string
  erros: IntegracaoErro[]
}

@Component
export default class ViewIntegracaoGeralRepasses extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()

  private loadAtualizar: boolean = false
  get loadingAtualizar() { return this.loadAtualizar }
  set loadingAtualizar(value: boolean) { this.loadAtualizar = value }

  private loadExecutar: boolean = false
  get loadingExecutar() { return this.loadExecutar }
  set loadingExecutar(value: boolean) { this.loadExecutar = value }

  private loadingLogs: number | null = null

  private cliente: string = ''
  private competencia: string = ''
  private observacao: string = ''
  private filtraStatus: string = 'todos'
  private competenciaMenu: boolean = false

  private dialogLogs: boolean = false

  private integracaoSelecionada: IntegracaoRepasse = {
    integracaoRepasseId: 0,
    recebimentoId: 0,
    mesReferencia: '',
    fontePagadoraNome: '',
    recebimentoStatus: '',
    recebimentoTipo: '',
    criadoEm: '',
    criadoPorNome: '',
    observacao: '',
    erros: []
  }

  get financeiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get statusOptions() {
    return [
      { label: 'Todos', value: 'todos' },
      { label: 'Iniciado', value: 'Iniciado' },
      { label: 'Erro', value: 'Erro' },
      { label: 'Concluído', value: 'Concluido' },
      { label: 'Finalizado', value: 'Finalizado' },
      { label: 'Cancelado', value: 'Cancelado' },
      { label: 'Pendente', value: 'Pendente' }
    ]
  }

  get competenciaFormatada(): string {
    if (!this.competencia) return ''

    const [ano, mes] = this.competencia.split('-')

    if (!ano || !mes) return ''

    return `${mes}/${ano}`
  }

  get integracaoAll(): IntegracaoRepasse[] {
    const lista = this.financeiroStore.integracaoGeralRepasses || []

    if (this.filtraStatus === 'todos' || !this.filtraStatus) return lista

    return lista.filter((item: IntegracaoRepasse) => item.recebimentoStatus === this.filtraStatus)
  }

  get fontePagadoraItems() {
    return this.financeiroStore.fontePagadoras
  }

  set fontePagadoraItems(value: any[]) {
    this.financeiroStore.setFontePagadora(value)
  }

  fecharMenuCompetencia() {
    this.competenciaMenu = false
  }

  limparCompetencia() {
    this.competencia = ''
    this.competenciaMenu = false
  }

  async atualizar() {
    this.loadingAtualizar = true

    const response = await this.financeiroStore.getIntegracaoGeralRepasses()

    if (!response) {
      console.error('Erro ao atualizar')
    }

    this.loadingAtualizar = false
  }

  async runIntegracao() {
    this.loadingExecutar = true

    const payload = {
      fontePagadoraId: this.cliente,
      mesReferencia: this.competencia ? `${this.competencia}-01` : '',
      observacao: this.observacao
    }

    const response = await this.financeiroStore.criarIntegracaoRepasse(payload)

    if (response && response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Integração executada com sucesso',
        icon: 'check_circle',
        color: '#2E7D32'
      })

      await this.atualizar()

      this.cliente = ''
      this.competencia = ''
      this.observacao = ''
      this.loadingExecutar = false
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: response.message || 'Erro ao executar integração',
      icon: 'warning',
      color: '#C62828'
    })

    this.loadingExecutar = false
  }

  async verLogs(integracao: IntegracaoRepasse) {
    this.loadingLogs = integracao.integracaoRepasseId

    this.integracaoSelecionada = {
      ...integracao,
      erros: integracao.erros || []
    }

    this.dialogLogs = true
    this.loadingLogs = null
  }

  statusLabel(status: string) {
    const labels: { [key: string]: string } = {
      Iniciado: 'Iniciado',
      Erro: 'Com erro',
      Concluido: 'Concluído',
      Finalizado: 'Finalizado',
      Cancelado: 'Cancelado',
      Pendente: 'Pendente'
    }

    return labels[status] || status
  }

  statusColor(status: string) {
    const colors: { [key: string]: string } = {
      Iniciado: 'blue',
      Erro: 'red',
      Concluido: 'green',
      Finalizado: 'green',
      Cancelado: 'grey',
      Pendente: 'orange'
    }

    return colors[status] || 'grey'
  }

  formatarData(data: string) {
    if (!data) return ''

    return new Date(data).toLocaleDateString('pt-BR')
  }

  formatarDataHora(data: string) {
    if (!data) return ''

    return new Date(data).toLocaleString('pt-BR')
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', {
      status: this.getRequestMessage.status,
      text: this.getRequestMessage.init.text
    })

    await this.financeiroStore.getFontePagadoraAll()
    await this.financeiroStore.getIntegracaoGeralRepasses()

    EventBus.$emit('clearLoadingRequest')
  }
}
